var map = {
	"./D100.png": "90fc",
	"./D20.png": "073c",
	"./D30.png": "9c5d",
	"./D50.png": "08ac",
	"./Duomix.png": "f3d3",
	"./M330.png": "5117",
	"./MP25.png": "06d5",
	"./Monomix.png": "5db7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79cb";